import type { RichtextStoryblok } from "../../component-types-sb";

/**
 * Parses the ingress (introduction) from a blog post's content
 * @param content The content of the blog post
 * @returns The parsed ingress as a string
 */
export const parseIngress = (content: RichtextStoryblok[] | undefined) => {
  return content?.[0]?.content?.map((item) => item.text).join(' ') ?? '';
};

/**
 * Calculates the reading time of a blog post
 * @param content The content of the blog post
 * @returns The reading time as a number
 */
export const calculateReadingTime = (content: RichtextStoryblok[] | undefined) => {
  if (!content) { return 0 };
  return Math.ceil(content.flatMap((item: any) =>
    item.content?.flatMap((subItem: any) => subItem.text || '') || []
  ).join(' ').split(' ').length / 200)
}
